import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
// const domainpath = "http://localhost:5000";

const Blog = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [singleBlogDetails, setSingleBlogDetails] = useState(null);

  useEffect(() => {
    async function getSingleBlog() {
      try {
        const slug_name = id.toLowerCase();
        const url = `${domainpath}/api/blog/${slug_name}/byslug`;

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error("Failed to fetch blog details");
        }

        const data = await response.json();
        setSingleBlogDetails(data?.blog);
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    }

    getSingleBlog();
  }, [id]);

  function createMarkup() {
    return { __html: singleBlogDetails?.html || "" };
  }

  return (
    <>
      <header>
        <title>{singleBlogDetails?.meta?.meta_title || "Blog"}</title>
        <meta
          name="description"
          content={singleBlogDetails?.meta?.meta_description || ""}
        />
        <meta
          name="keywords"
          content={singleBlogDetails?.meta?.meta_keyword || ""}
        />
      </header>
      <section className="breadcumb no-bg">
        <div className="mainbreadcumb ">
          <div className="container">
            {loading ? (
              <p>Loading...</p>
            ) : singleBlogDetails ? (
              <div className="single_blog">
                <h1>{singleBlogDetails.title}</h1>
                <img
                  src={
                    singleBlogDetails.featured_image
                      ? `${domainpath}/${singleBlogDetails.featured_image}`
                      : "./img/default-blog.jpg"
                  }
                  alt={singleBlogDetails.title}
                  // onError={(e) => (e.target.src = "./img/default-blog.jpg")}
                />
                <div className="blog_content">
                  <span dangerouslySetInnerHTML={createMarkup()}></span>
                </div>
              </div>
            ) : (
              <p>Blog not found.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
